(function () {
  var formId = 'form8fcd2d27e44741869f5aa8abbea96e0f';
  var interestIds = [
    'd9d1e16d-1c23-4efd-abc3-30335489c7bb',
    '7b28786e-41be-4936-a980-b6cc96043c9a',
    '43261cb5-dbf0-48c5-a86b-8d1bb552a688'
  ];

  function groupInterestFields() {
    var form = document.getElementById(formId);
    if (!form || form.querySelector('.prelaunch__interest-group')) return !!form;

    var fields = interestIds.map(function (id) { return document.getElementById(id); });
    var title = Array.prototype.find.call(form.querySelectorAll('h4'), function (heading) {
      return heading.textContent.indexOf('Products you are interested in') !== -1;
    });
    if (!title || fields.some(function (field) { return !field; })) return false;

    var rows = fields.map(function (field) { return field.closest('.ace-cf-row'); });
    var titleRow = title.closest('.ace-cf-row');
    var parent = rows[0] && rows[0].parentElement;
    if (!parent || !titleRow || titleRow.parentElement !== parent ||
        rows.some(function (row) { return !row || row.parentElement !== parent; })) return false;

    var group = document.createElement('fieldset');
    group.className = 'prelaunch__interest-group';
    var legend = document.createElement('legend');
    legend.textContent = title.textContent;
    group.appendChild(legend);
    parent.insertBefore(group, rows[0]);
    rows.forEach(function (row) { group.appendChild(row); });
    titleRow.remove();
    return true;
  }

  window.acerillFormBuilderOnFormLoaded = groupInterestFields;
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', groupInterestFields, { once: true });
  } else {
    groupInterestFields();
  }
  if (!groupInterestFields()) {
    var observer = new MutationObserver(function () {
      if (groupInterestFields()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.acerillFormBuilderFormValidation = function () {
    if (!document.getElementById(formId)) return;
    var hasInterest = interestIds.some(function (id) {
      var field = document.getElementById(id);
      return field && field.checked;
    });
    if (!hasInterest) return 'Choose at least one product of interest.';
  };
})();